var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"leyenda"},[_c('p',[_vm._v("Registros")]),_c('p',[_vm._v("Promocionales")])])])
}]

export { render, staticRenderFns }